$(() => {
    //selectors
    const orgnrbtn = document.querySelector('#organizationid-btn');
    //const clearformbtn = document.querySelector("#organizationid-btn");

    const loader = document.querySelector('#organizationid-btn .lds-dual-ring');
    const orgnr = document.querySelector(
        '#RegistrationPageViewModel_OrganizationCustomer_IdentificationNumber'
    );
    const orgname = document.querySelector(
        '#RegistrationPageViewModel_OrganizationCustomer_OrganizationName'
    );
    const address = document.querySelector(
        '#RegistrationPageViewModel_OrganizationCustomer_Address'
    );
    const address2 = document.querySelector(
        '#RegistrationPageViewModel_OrganizationCustomer_Address2'
    );
    const postalcode = document.querySelector(
        '#RegistrationPageViewModel_OrganizationCustomer_PostalCode'
    );
    const city = document.querySelector('#RegistrationPageViewModel_OrganizationCustomer_City');
    const bnode = document.querySelector(
        '#RegistrationPageViewModel_OrganizationCustomer_BisnodeId'
    );
    //const email = document.querySelector("#RegistrationPageViewModel_OrganizationCustomer_Email");
    //const mobile = document.querySelector("#RegistrationPageViewModel_OrganizationCustomer_MobileNumber");
    //const firstname = document.querySelector("#RegistrationPageViewModel_OrganizationCustomer_FirstName");
    //const lastname = document.querySelector("#RegistrationPageViewModel_OrganizationCustomer_LastName");
    //const orgnrfeedback = document.querySelector("#orgfeedback");

    const togglecheckbox = document.querySelector('#togglecheckbox');

    //eventlistners
    if (orgnrbtn) {
        orgnr.addEventListener('blur', (x) => orgnr.classList.remove('is-invalid'));
        orgnrbtn.addEventListener('click', fetchCompanydata);
    }
    if (togglecheckbox) {
        togglecheckbox.addEventListener('change', reloadPage);
    }

    //functions
    function fetchCompanydata(event) {
        event.preventDefault();
        if (!orgnr && !orgnr.value.length > 9) {
            return;
        }
        loader.classList.add('loading');
        orgnr.classList.remove('is-invalid');
        orgnr.parentNode.lastElementChild.innerText =
            'Kontrollera att du skrivit in rätt organisationsnummer, det ska vara 10 siffror';

        const response = fetch(
            '/api/registrationApi/GetCompanyAddress?organizationNumber=' + orgnr.value
        )
            .then((response) => response.json())
            .then((data) => {
                loader.classList.remove('loading');
                //console.log(data);
                var json = JSON.parse(data.Content);
                if (json.success) {
                    if (json.payload.organizationName == '') {
                        orgnr.classList.add('is-invalid');
                        //orgnr.parentNode.lastElementChild.innerText = 'Vi kunde inte hitta ett företag med angivet organisationsnummer';
                        orgnr.parentNode.lastElementChild.innerText =
                            'Just nu svarar inte tjänsten, Var god försök senare.';
                        return;
                    }
                    updateValues(json.payload);
                } else if (json.error) {
                    orgnr.classList.add('is-invalid');
                }
            })
            .catch((e) => {
                console.log('There has been a problem with your fetch operation:' + e);
            });
        console.log(response);
    }

    function reloadPage(event) {
        const target = event.target;
        const url = target.dataset.currenturl;
        const view = target.checked ? 'person' : 'company';

        if (!window.location.search) {
            window.location.href = url + `?view=${view}`;
        } else if (window.location.search.indexOf('view=') >= 0) {
            window.location.href =
                url + window.location.search.replace(/view=[^&]*/, `view=${view}`);
        } else {
            window.location.href = url + window.location.search + `&view=${view}`;
        }
    }

    function updateValues(payload) {
        if (payload.identificationNumber != null) {
            orgnr.value = payload.identificationNumber;
        }
        if (payload.organizationName != null) {
            orgname.value = payload.organizationName;
        }
        if (payload.address != null) {
            address.value = payload.address;
            address.readOnly = true;
        }
        if (payload.address2 != null) {
            address2.value = payload.address2;
            address2.readOnly = true;
        }
        if (payload.postalCode != null) {
            postalcode.value = payload.postalCode;
            postalcode.readOnly = true;
        }
        if (payload.city != null) {
            city.value = payload.city;
            city.readOnly = true;
        }
        if (payload.BisnodeId != null) {
            bnode.value = payload.BisnodeId;
            bnode.readOnly = true;
        }
        //if (payload.email != null) {
        //    email.value = email.value === "" ? payload.email : email.value;
        //}
        //if (payload.mobileNumber != null) {
        //    mobile.value = mobile.value === "" ? payload.mobileNumber : mobile.value;
        //}
        //if (payload.firstName != null) {
        //    firstname.value = firstname.value === "" ? payload.firstName : firstname.value;
        //}
        //if (payload.lastName != null) {
        //    lastname.value = lastname.value === "" ? payload.lastName : lastname.value;
        //}
    }
});
